export interface IContactSort {
    name: string;
    key: string;
    sortOrder: 'ascend' | 'descend' | '';
 }

